import { Tabs, Box, Card, Grid, Spinner } from "@radix-ui/themes";
import React, { useEffect, useContext } from "react";
import MediaPlayer from "components/MediaPlayer";
import PodcastsView from "components/PodcastsView";
import CoverCard from "components/CoverCard";
import { YourGeneratedPodcastContext } from "context/LibraryYourGeneratedPodcastContext";
import { CurrentlyPlayingContext } from "context/CurrentlyPlayingContext";
import imageMapping from "imageMapping";
import coverZ from "alphabet_images/Z.png";

const LibraryView = () => {
  const { currentYourGeneratedPodcast } = useContext(
    YourGeneratedPodcastContext
  );
  const { currentlyPlaying } = useContext(CurrentlyPlayingContext);

  const filteredPodcasts = currentYourGeneratedPodcast.filter(
    (podcast) => podcast.status === "COMPLETE"
  );

  if (currentYourGeneratedPodcast.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
        }}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          paddingTop: "10px",
          width: "100%",
        }}
      >
        <div>
          <Card>
            <Tabs.Root defaultValue="your">
              <Tabs.List>
                <Tabs.Trigger value="your" style={{ cursor: "pointer" }}>
                  All
                </Tabs.Trigger>
              </Tabs.List>

              <Box pt="3">
                <Tabs.Content value="your">
                  <PodcastsView isMine={true} />
                  <Grid columns="8" gap="5">
                    {filteredPodcasts
                      .sort(
                        (a, b) =>
                          new Date(b.created_at) - new Date(a.created_at)
                      )
                      .map((podcast) => {
                        const firstChar = podcast.topic.charAt(0).toUpperCase();
                        const coverImage = imageMapping[firstChar] || coverZ;
                        return (
                          <CoverCard
                            title={podcast.topic}
                            caption={podcast.created_by}
                            cover={coverImage}
                            color="hsl(0, 0%, 50%, 0.2)"
                            key={podcast.id}
                            audioFileUrl={podcast.audio_file}
                            id={podcast.id}
                          />
                        );
                      })}
                  </Grid>
                </Tabs.Content>
              </Box>
            </Tabs.Root>
          </Card>
        </div>

        {currentlyPlaying && (
          <div
            style={{
              paddingLeft: "10px",
              paddingRight: "10px",
              paddingTop: "10px",
              width: "90%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <MediaPlayer />
          </div>
        )}
      </div>
    </>
  );
};

export default LibraryView;
